import { inject, Injectable, Type } from '@angular/core';
import { JepGraphic } from '@jeppesen-foreflight/jmkw-types';
import { Airport } from '../plugins/navigation/typings/features/airport-class';
import { Airspace } from '../plugins/navigation/typings/features/airspace-class';
import { Airway } from '../plugins/navigation/typings/features/airway-class';
import { Amdb } from '../plugins/navigation/typings/features/amdb-class';
import { FeatureDetail } from '../plugins/navigation/typings/features/feature-detail';
import { Navaid } from '../plugins/navigation/typings/features/navaid-class';
import { Runway } from '../plugins/navigation/typings/features/runway-class';
import { Waypoint } from '../plugins/navigation/typings/features/waypoint-class';
import { NGXLogger } from 'ngx-logger';
import { NavigationFeatureType } from '../plugins/navigation/typings/navigation-feature-type';
import { NavigationFeature } from '../plugins/navigation/typings/navigation-feature';

@Injectable({ providedIn: 'root' })
export class FeatureDetailService {
  private readonly _logger = inject(NGXLogger);
  private readonly _navEntityTypes: Record<
    NavigationFeatureType,
    Type<NavigationFeature>
  > = {
    airport: Airport,
    airspace: Airspace,
    airway: Airway,
    amdb: Amdb,
    navaid: Navaid,
    runway: Runway,
    waypoint: Waypoint
  };

  /**
   * Creates a FeatureDetail instance from a given JepGraphic.
   *
   * @param {JepGraphic} candidate - The hitTest result object containing navigation feature attributes.
   * @returns {FeatureDetail} The created FeatureDetail instance based on the navigation type.
   */
  createFromGraphic(candidate: JepGraphic): FeatureDetail {
    const construct =
      this._navEntityTypes[
        candidate.attributes['nav_type'] as NavigationFeatureType
      ];
    const result = new construct(candidate);
    this._logger.trace(
      `[FeatureDetailService] Created new ${candidate.attributes['nav_type']}:`,
      result
    );
    return result;
  }
}
